import { render, staticRenderFns } from "./ListItemAddForm.vue?vue&type=template&id=db0aae12&scoped=true&"
import script from "./ListItemAddForm.vue?vue&type=script&lang=js&"
export * from "./ListItemAddForm.vue?vue&type=script&lang=js&"
import style0 from "./ListItemAddForm.vue?vue&type=style&index=0&id=db0aae12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0aae12",
  null
  
)

export default component.exports